import {
  CONTENT_TYPE_FIELD,
  CpsDocumentMetadata,
  DOC_ID_FIELD,
  EXTENSION_FIELD,
  FILE_FIELD,
  LOCKED_FIELD,
  PERMISSIONS_FIELD
} from '@cs-cms/types';

const CREATED_FIELD = 'Cps_Created';
const FILE_NAME_FIELD = 'Cps_FileName';

const NON_TRANSFERABLE_FIELDS = new Set<string>([
  DOC_ID_FIELD,
  CREATED_FIELD,
  FILE_NAME_FIELD,
  EXTENSION_FIELD,
  LOCKED_FIELD,
  PERMISSIONS_FIELD,
  FILE_FIELD,
  CONTENT_TYPE_FIELD
]);

export function isTransferableMetadataField(fieldName: string): boolean {
  return !NON_TRANSFERABLE_FIELDS.has(fieldName);
}

export function buildSimilarDocumentMetadata(metadata: CpsDocumentMetadata): CpsDocumentMetadata {
  const transferableMetadata: CpsDocumentMetadata = {};

  for (const [fieldName, fieldValue] of Object.entries(metadata)) {
    if (!isTransferableMetadataField(fieldName)) {
      continue;
    }
    transferableMetadata[fieldName] = fieldValue;
  }

  return transferableMetadata;
}
